import React, { useCallback } from "react";
import { AxiosRequestConfig } from "axios";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "StoreTypes";
import { Dispatch } from "redux";
import { SearchContext, SearchContextProps } from "../contexts/SearchContext";
import { getFile } from "../../actions/getFile";

interface Props extends PropsFromRedux {
  children: JSX.Element | JSX.Element[];
}

export const SearchProviderComponent = ({
  children,
  getFile,
  fileState,
}: Props) => {
  const searchStateAndActions: SearchContextProps = {
    fileState,
    getFile: useCallback(
      (params, config) => getFile(params, config),
      [getFile]
    ),
  };

  return (
    <SearchContext.Provider value={searchStateAndActions}>
      {children}
    </SearchContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  fileState: state.fileReducer,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getFile: (params: string | undefined, config: AxiosRequestConfig) =>
    getFile(dispatch, params, config),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export const SearchProvider = connector(SearchProviderComponent);
